import apiClient from './api';

const feedbackService = {
  submitFeedback: async (payload) => {
    const response = await apiClient.post('/feedback/', payload);
    return response.data;
  },

  getFeedbacks: async (params = {}) => {
    const response = await apiClient.get('/feedback/admin/', { params });
    return response.data;
  },

  updateFeedbackStatus: async (id, payload) => {
    const response = await apiClient.patch(`/feedback/admin/${id}/`, payload);
    return response.data;
  },
};

export default feedbackService;
